var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 12 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.603 19.193l-8.207-8.06a.56.56 0 010-.803l8.207-8.06a1.313 1.313 0 000-1.88 1.371 1.371 0 00-1.914 0L.595 9.32a1.97 1.97 0 000 2.82l9.094 8.932c.529.52 1.386.52 1.914 0a1.313 1.313 0 000-1.88z",
    fill: "currentColor"
  })));
}
export default SvgLeftArrowBold;